module.exports = new __parcel__URL__("card_tomcat.9a93181e.jpg").toString();